<div class="row mt-3 border-bottom">
    <div class="select-column col-2">
        @if (!participant.hasCopy) {
            <div class="checkbox-container">
                <input
                    type="checkbox"
                    [ngModel]="participant.selectedInParticipantCopiesModal"
                    (change)="participantChecked()"
                    class="form-control"
                    [attr.aria-label]="'PARTICIPANT_LIST_ENTRY_SELECT_PARTICIPANT_ARIA_LABEL' | translate"
                />
                @if (participant.selectedInParticipantCopiesModal) {
                    <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                }
            </div>
        }
        @if (participant.hasCopy && participant.submittedOn.length === 0) {
            <fa-icon class="info-icon" [icon]="faFile" size="2x"></fa-icon>
        }
        @if (participant.submittedOn.length > 0) {
            <fa-icon class="info-icon" [icon]="faFileUpload" size="2x"></fa-icon>
        }
    </div>
    <div class="col-md-3 col-8 mt-2 mt-md-0">{{ participant.firstName }} {{ participant.lastName }}</div>
    <div class="offset-2 offset-md-0 col-md-4 col-10 mt-2 mt-md-0">{{ participant.email }}</div>
    <div class="col-md-3 col-12 mt-2 mt-md-0 text-end mb-1">
        <button
            type="button"
            class="btn btn-secondary me-1"
            (click)="editParticipant()"
            [disabled]="participant.submittedOn.length !== 0"
            [attr.aria-label]="'PARTICIPANT_LIST_ENTRY_EDIT_PARTICIPANT_ARIA_LABEL' | translate"
        >
            <fa-icon [icon]="faPencil"></fa-icon>
        </button>
        <button
            type="button"
            class="btn btn-secondary me-1"
            (click)="deleteParticipantForm()"
            [disabled]="!participant.hasCopy"
            [attr.aria-label]="'PARTICIPANT_LIST_ENTRY_DELETE_PARTICIPANT_COPY_ARIA_LABEL' | translate"
        >
            <fa-icon [icon]="faTrashAlt" translate="F4M_PARTICIPANTS_DELETE_COPY_LABEL"></fa-icon>
        </button>
        <button
            type="button"
            class="btn btn-warning"
            (click)="deleteParticipant()"
            [disabled]="participant.submittedOn.length !== 0"
            [attr.aria-label]="'PARTICIPANT_LIST_ENTRY_DELETE_PARTICIPANT_ARIA_LABEL' | translate"
        >
            &times;
        </button>
    </div>
</div>
